// Compare an url containing a query with the current browser one
// It will return true if the two queries are not the same
export default function isANewQuery(url?: string) {
  const { search } = window.location
  const query = url ? url.split('?')[1] : ''

  return query !== search.replace('?', '')
}
